/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_X_Move_LeftInputs */



/**
* | output |
* | --- |
* | "Move Left 1 Character" |
*
* @param {Input_Position_X_Move_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_x_move_left = /** @type {((inputs?: Input_Position_X_Move_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_X_Move_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déplacer à Gauche de 1 Caractère")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bewege dich um 1 Zeichen nach links")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta a sinistra di 1 carattere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместить влево на 1 символ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover 1 carácter a la izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向左移动 1 个字符")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1文字左に移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाईं ओर 1 अक्षर खिसकाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mover 1 caractere para a esquerda")
	return /** @type {LocalizedString} */ ("Move Left 1 Character")
});